export default __webpack_public_path__ + "static/media/ic_listeners.24f8b574.svg";